import { Link } from "react-router-dom";

export function LinkButton({text, url}) {
    return (
        <Link className="link-button" to={url}>
            <span className="button-text">{text}</span>
        </Link>
    )
}